<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Configure Email Template</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateEmailTemplate" v-if="emailTemplate">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                          <br/>
                          <legend>Email Header</legend><hr>
                          <br/>
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="emailTemplate.mainHeading"
                                          label="Main Heading"
                                          placeholder="Enter Template Main Heading"
                                          v-validate="rules.mainHeading"
                                          data-vv-name="mainHeading"
                                          cus-name="mainHeading"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                             </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="emailTemplate.imageUrl"
                                      label="Main Image URL"
                                      placeholder="Enter URL"
                                      v-validate="rules.imageUrl"
                                      data-vv-name="imageUrl"
                                      cus-name="imageUrl"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area
                                      rows="5" type="text"
                                      v-model="emailTemplate.para1"
                                      label="Enter First Paragraph"
                                      placeholder="Enter First Paragraph"
                                      v-validate="rules.para1"
                                      data-vv-name="para1"
                                      cus-name="para1"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area rows="5" type="text"
                                      v-model="emailTemplate.para2"
                                      label="Enter Second Paragraph"
                                      placeholder="Enter Second Paragraph"
                                      v-validate="rules.para2"
                                      data-vv-name="para2"
                                      cus-name="para2"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <br>
                          <br/>
                          <legend>Email Template Sections</legend><hr>
                          <br/>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="emailTemplate.commCoachingHeading"
                                      label="Common Coaching Heading"
                                      placeholder="Enter Common Coaching Heading"
                                      v-validate="rules.commCoachingHeading"
                                      data-vv-name="commCoachingHeading"
                                      cus-name="commCoachingHeading"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area rows="5" type="text"
                                      v-model="emailTemplate.commCoachingPara"
                                      label="Common Coaching Paragraph"
                                      placeholder="Enter Common Coaching Paragraph"
                                      v-validate="rules.commCoachingPara"
                                      data-vv-name="commCoachingPara"
                                      cus-name="commCoachingPara"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="emailTemplate.liveEventHeading"
                                      label="Live Event Heading"
                                      placeholder="Enter Live Event Heading"
                                      v-validate="rules.liveEventHeading"
                                      data-vv-name="liveEventHeading"
                                      cus-name="liveEventHeading"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area rows="5" type="text"
                                          v-model="emailTemplate.liveEventPara"
                                          label="Live Event Paragraph"
                                          placeholder="Live Event Paragraph"
                                          v-validate="rules.liveEventPara"
                                          data-vv-name="liveEventPara"
                                          cus-name="liveEventPara"
                                          :has-errors="errors"
                                          :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="emailTemplate.customContentHeading"
                                      label="Custom Content Heading"
                                      placeholder="Enter Custom Content Heading"
                                      v-validate="rules.customContentHeading"
                                      data-vv-name="customContentHeading"
                                      cus-name="customContentHeading"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area rows="5" type="text"
                                          v-model="emailTemplate.customContentPara"
                                          label="Custom Content Paragraph"
                                          placeholder="Custom Content Paragraph"
                                          v-validate="rules.customContentPara"
                                          data-vv-name="customContentPara"
                                          cus-name="customContentPara"
                                          :has-errors="errors"
                                          :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="emailTemplate.shareVideoHeading"
                                      label="Share Video Heading"
                                      placeholder="Enter Share Video Heading"
                                      v-validate="rules.shareVideoHeading"
                                      data-vv-name="shareVideoHeading"
                                      cus-name="shareVideoHeading"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area rows="5" type="text"
                                          v-model="emailTemplate.shareVideoPara"
                                          label="Share Video Paragraph"
                                          placeholder="Share Video Paragraph"
                                          v-validate="rules.shareVideoPara"
                                          data-vv-name="shareVideoPara"
                                          cus-name="shareVideoPara"
                                          :has-errors="errors"
                                          :is-fields="fields">
                            </fg-text-area>
                          </div>
                        </div>
                        </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Email Template
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'Edit_Email_Template',
        created (){
        this.$store.dispatch('GET_EMAIL_TEMPLATE').then(() =>{
            this.emailTemplate = this.getEmailTemplate;
        })
    },
    data () {
        return {
            emailTemplate: this.getEmailTemplate || {},
            rules: {
              mainHeading: {required : true, min: 5},
              imageUrl: {required : true, min : 10},
              para2: {required : true, min : 10},
              commCoachingHeading: {required : true, min : 10},
              commCoachingPara: {required : true, min : 10},
              liveEventHeading: {required : true, min : 10},
              liveEventPara: {required : true, min : 10},
              customContentHeading: {required : true, min : 10},
              customContentPara: {required : true, min : 10},
              shareVideoHeading: {required : true, min : 10},
              shareVideoPara: {required : true, min : 10}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corporations = res;
            console.log("this.corporations : ", this.corporations);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateEmailTemplate() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        let updateEmailTemplate = () =>{
                            this.$store.dispatch('UPDATE_EMAIL_TEMPLATE_CORP', this.emailTemplate)
                                    .then((res) => {
                                        console.log("UPDATE_DEMO_EVENT res : ", res);
                                        this.showPopup('Success!', 'Email Template is successfully updated', 'success')
                                    })
                                    .catch(err => {
                                        this.showPopup('Error!', 'some thing happen wrong', 'error')
                                        console.log("UPDATE_EVENT API error : ", err);
                                    })
                        }
                      updateEmailTemplate();
                    }
                })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'getEmailTemplate']) }
    }
</script>
<style scoped>
  legend {
    color: deepskyblue;
    text-align: center;
    padding: 25px;
    /* text-underline-position: under; */
  }
</style>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/EmailTemplate.vue